import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { scrollToHash } from 'wanderu-utils';

import IndividualReviews from './IndividualReviews/IndividualReviews';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './UserReviews.scss';

function UserReviews(props) {
    const [hideSection, setHideSection] = useState(true);
    const [triggerBorder, setTriggerBorder] = useState(false);

    const {
        reviews,
        namespace,
        t,
        startReviews,
        endReviews,
        defaultNumReviews,
    } = props;

    const handleReviews = () => {
        setHideSection(!hideSection);
        setTriggerBorder(!triggerBorder);
        scrollToHash('last-review-anchor', { duration: 600 });
    };

    return (
        <article>
            <div id="firstReviewsContainer">
                {reviews.slice(0, defaultNumReviews).map((review, index) => {
                    return (
                        <IndividualReviews
                            firstSection={triggerBorder}
                            id={index === defaultNumReviews - 1
                                ? 'last-review-anchor'
                                : undefined}
                            key={review.stats.reviewIndividualId}
                            namespace={namespace}
                            review={review}
                        />
                    );
                })}
            </div>
            <div
                aria-labelledby="hiddenReviews"
                hidden={hideSection}
                id="secondReviewsContainer"
                role="region"
            >
                {reviews.slice(startReviews, endReviews).map((review) => {
                    return (
                        <IndividualReviews
                            key={review.stats.reviewIndividualId}
                            namespace={namespace}
                            review={review}
                            secondSection={triggerBorder}
                        />
                    );
                })}
            </div>
            {reviews.length > defaultNumReviews && (
                <div className={styles.buttonContainer}>
                    <Button
                        aria-controls="secondReviewsContainer"
                        aria-expanded={!hideSection}
                        className={styles.showHideButton}
                        id="hiddenReviews"
                        onClick={() => handleReviews()}
                    >
                        {hideSection
                            ? t(`${namespace}:travelReviewCommonShowMoreReviews`)
                            : t(`${namespace}:travelReviewCommonHideReview`)}
                    </Button>
                </div>
            )}
        </article>
    );
}

UserReviews.propTypes = {
    namespace: PropTypes.string.isRequired,
    reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export {
    UserReviews,
};

export default localize(UserReviews);
